var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-more",on:{"click":_vm.loadMore}},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }